import { Routes } from '@angular/router';
import { EmailVerificationComponent } from './auth/components/email-verification/email-verification.component';
import { EmailInviteComponent } from './auth/components/email-invite/email-invite.component';
import { NotFoundComponent } from './auth/components/not-found/not-found.component';

export const routes: Routes = [
  {
    path: '',
    loadChildren: () =>
      import('./auth/auth-routing.module').then((m) => m.AuthRoutingModule),
  },
  {
    path: 'EN',
    loadChildren: () =>
      import('./dashboard/dashboard-routing.module').then(
        (d) => d.DashboardRoutingModule
      ),
    data: {
      language: 'en',
    },
  },
  {
    path: 'ES',
    loadChildren: () =>
      import('./dashboard/dashboard-routing.module').then(
        (d) => d.DashboardRoutingModule
      ),
    data: {
      language: 'es',
    },
  },

  {
    path: 'EN',
    loadChildren: () =>
      import('./payment/payment-routing.module').then(
        (p) => p.PaymentRoutingModule
      ),
    data: {
      language: 'en',
    },
  },
  {
    path: 'ES',
    loadChildren: () =>
      import('./payment/payment-routing.module').then(
        (p) => p.PaymentRoutingModule
      ),
    data: {
      language: 'es',
    },
  },
  {
    path: 'EN',
    loadChildren: () =>
      import('./dashboard/dashboard-routing.module').then(
        (d) => d.DashboardRoutingModule
      ),
    data: {
      language: 'en',
    },
  },
  {
    path: 'ES',
    loadChildren: () =>
      import('./dashboard/dashboard-routing.module').then(
        (d) => d.DashboardRoutingModule
      ),
    data: {
      language: 'es',
    },
  },
  {
    path: 'EN',
    loadChildren: () =>
      import('./profile/profile-routing.module').then(
        (p) => p.ProfileRoutingModule
      ),
    data: {
      language: 'en',
    },
  },
  {
    path: 'ES',
    loadChildren: () =>
      import('./profile/profile-routing.module').then(
        (p) => p.ProfileRoutingModule
      ),
    data: {
      language: 'es',
    },
  },

  {
    path: 'emailverification/:email',
    component: EmailVerificationComponent,
  },

  {
    path: 'inviteverificationaccept/:email',
    component: EmailInviteComponent,
    data: {
      validate: true,
    },
  },
  {
    path: 'inviteverificationdenegad/:email',
    component: EmailInviteComponent,
    data: {
      validate: false,
    },
  },
  {
    path: '**',
    component: NotFoundComponent,
    data: {
      validate: false,
    },
  },
];
